module.exports = __webpack_public_path__ + "/static/assets/96aa336809f7ad4dbf5b003d8a28a6bd.png";